
import mentionPlugin from './mentionPlugin'

export default mentionPlugin